<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div :class="['IM_2_' + this.id]">
    <div class="w-100 p-3" style="text-align: center; height: 92.3vh;">
      <vue-word-cloud
        style="height: 74.5vh;"
        :words="word_cloud"
        :color="randomColors"
        :font-size-ratio="4"
        :rotation="([, weight]) => (Math.random() > 0.6 ? 1 : 0.75)"
        :spacing="0.35"
        font-family="Faune"
      />
    </div>
    <NextBtn class="send" :url="'/immersion02/' + (this.id + 1)" text="Rejoindre Léon" />
  </div>
</template>

<script>
// @ is an alias to /src
import NextBtn from "@/components/NextButton";
import Service from "@/services/memoryMap";
import * as Sentry from "@sentry/browser";
import VueWordCloud from "vuewordcloud";

export default {
  name: "IM_2_5",
  data: function () {
    return {
      id: 6,
      word_cloud: [],
      colors: ["#662008", "#C7644E", "#E58D2E", "#875A3C", "#485466"]
    };
  },
  methods: {
    emitMusic: function (action, id) {
      this.$emit("audio", { action: action, id: id });
    },
    randomColors() {
      return this.colors[Math.floor(Math.random() * Math.floor(this.colors.length))];
    }
  },
  created() {
    Service.getWordCloud()
      .then((words) => {
        this.word_cloud = words;
      })
      .catch((error) => {
        Sentry.captureException(new Error(error));
      });
  },
  components: { NextBtn, VueWordCloud }
};
</script>

<style scoped lang="scss">
.send {
  position: absolute;
  bottom: 4vh;
  right: 6vw;
  z-index: 1000000;
}
</style>
